import { render, staticRenderFns } from "./buttonConfig.vue?vue&type=template&id=252cee93&"
import script from "./buttonConfig.vue?vue&type=script&lang=js&"
export * from "./buttonConfig.vue?vue&type=script&lang=js&"
import style0 from "./buttonConfig.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports